import styled from 'styled-components';

export const TabsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
`;

export const TabsContainer = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #3a3a3a;
  overflow-x: auto;
  overflow-y: hidden;
  flex-shrink: 0;

  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const TabContentContainer = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0px 0px 16px 0px;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  /* Firefox: use scroll with reserved space */
  &.firefox-windows {
    overflow-y: auto;
    padding: 0px 10px 16px 0px;
  }

  &.hideScrollbar {
    overflow-y: hidden !important;
    // height: auto;
    min-height: 0;
    padding-bottom: 30px;
    scrollbar-gutter: stable;
    overflow-x: hidden;
  }

  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;
